import Service from "../Service";
const resource = "TicEquipment/";

export default {
  save(cmp, requestID) {
    console.log(cmp);
    return Service.post(resource + "save", cmp, {
      params: { requestID: requestID },
    });
  },

  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },

  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID: requestID },
    });
  },

  excel(parameters, requestID) {
    return Service.post(resource + "excel", parameters, {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      params: { requestID },
    });
  },

  history(CgeID, requestID) {
    return Service.post(
      resource + "history",
      {},
      {
        params: { CgeID, requestID },
      }
    );
  },

  statistics(parameters = {}, requestID) {
    return Service.post(resource + "statistics", parameters, {
      params: { requestID },
    });
  },

  findBySerie(parameters, requestID) {
    return Service.post(resource + "findBySerie", parameters, {
      params: { requestID },
    });
  },

  TicSaveRental(parameters, requestID) {
    return Service.post(resource + "TicSaveRental", parameters, {
      params: { requestID },
    });
  },

  TicEquipmentRental(parameters, requestID) {
    return Service.post(resource + "TicEquipmentRental", parameters, {
      params: { requestID },
    });
  },

  updateEmailSentWarehouse(CgeID, requestID) {
    return Service.post(
      resource + "updateEmailSentWarehouse",
      {},
      {
        params: { CgeID, requestID },
      },
    );
  },
};
